import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of as observableOf, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { Profile } from '@shared/models/profile.interface';
import { catchError } from 'rxjs/operators';
import { MessageDisplayService } from '@shared/message-display/message-display.service';
import { environment } from '@env/environment';
import { AuthService } from './auth.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  

  private profile: any;

  // private userDataSource = new BehaviorSubject(null);
  // currentUserData = this.userDataSource.asObservable();

  // private userInfoSource = new BehaviorSubject(this.profile);
  // currentUserInfo = this.userInfoSource.asObservable();

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private authService: AuthService,
    private messageDisplayService: MessageDisplayService) {
  }

  private handleErrors = (error: any): Observable<any> => {
    this.messageDisplayService.error(error.message);
    return throwError(error);
  }

  get_user_profile(): Observable<Profile> {
    if (this.profile && Object.keys(this.profile).length > 0) {
      return observableOf(this.profile);
    }
    const connectedUser = this.authService.getCurrentUser();
    const userEmail = connectedUser.email ? connectedUser.email : '';
    let params = new HttpParams().set("email",userEmail);
    return this.http.get<Profile>(environment.apiUrl + '/fraud/profile', {params: params }).pipe(
      catchError(this.handleErrors),
      map(profile => {
        if(profile && profile.email === null){
          this.authService.signOut();
          this.translate.get('key__error_user_not_exists')
          .subscribe(translatedMessage => this.messageDisplayService.warn(translatedMessage));
          return undefined;
        }else{
          this.profile = profile;
          return profile;
        }

      }));
  }


  // updateUserInfo(userInfo: any): void {
  //   this.userInfoSource.next(userInfo);
  // }

  // dispatchUserData(userData: any): void {
  //   this.userDataSource.next(userData);
  // }
}
